import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Injectable()
export class DatepickerAriaIntl extends MatDatepickerIntl {
  constructor() {
    super();
    this.calendarLabel = 'Calendrier';
    this.closeCalendarLabel = 'Fermer le calendrier';
    this.nextMonthLabel = 'Mois suivant';
    this.nextMultiYearLabel = '24 années suivantes';
    this.nextYearLabel = 'Année suivante';
    this.openCalendarLabel = 'Ouvrir le calendrier';
    this.prevMonthLabel = 'Mois précédent';
    this.prevMultiYearLabel = '24 années précédentes';
    this.prevYearLabel = 'Année précédente';
    this.switchToMonthViewLabel = 'Choisissez une date';
    this.switchToMultiYearViewLabel = 'Choisissez un mois et une année ';
  }
}
